import LocalStorageHelper from "../helpers/LocalStorageHelper";
import { RestHelper } from "../helpers/RestHelper";
import { enumLocalStorageArgs } from "../helpers/common.constants";

export class TaskTemplateService {
  private _restHelper;

  constructor() {
    this._restHelper = new RestHelper();
  }


  async GetAll(payload: any) {
    const url: string = "TaskTemplate/GetAll";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

}
